import { createContext, useContext, useState, useMemo, ReactNode } from 'react';

interface LocationFilterContextValue {
  selectedLocation: string;
  setSelectedLocation: (location: string) => void;
  locationIds: string[] | undefined;
}

const LocationFilterContext = createContext<LocationFilterContextValue | null>(null);

export const LocationFilterProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedLocation, setSelectedLocation] = useState<string>('');

  const value = useMemo(
    () => ({
      selectedLocation,
      setSelectedLocation,
      locationIds: selectedLocation ? [selectedLocation] : undefined,
    }),
    [selectedLocation]
  );

  return (
    <LocationFilterContext.Provider value={value}>
      {children}
    </LocationFilterContext.Provider>
  );
};

export const useLocationFilter = () => {
  const ctx = useContext(LocationFilterContext);
  if (!ctx) {
    throw new Error('useLocationFilter must be used within LocationFilterProvider');
  }
  return ctx;
};

